"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var DropdownControl_1 = tslib_1.__importDefault(require("./DropdownControl"));
var translations_1 = require("../../utils/translations");
var dropdowns_1 = require("../../constants/dropdowns");
function getPushpinProperty(props) {
    var _a, _b, _c;
    return (_c = (_b = (_a = props.properties) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.viewport) !== null && _c !== void 0 ? _c : { area: "auto" };
}
function PushpinViewportControl(props) {
    var area = getPushpinProperty(props).area;
    var disabled = props.disabled, properties = props.properties, pushData = props.pushData, intl = props.intl;
    return (react_1.default.createElement("div", { className: "s-pushpin-viewport-control" },
        react_1.default.createElement(DropdownControl_1.default, { value: area, valuePath: "viewport.area", labelText: "properties.viewport.area.title", disabled: disabled, showDisabledMessage: disabled, properties: properties, pushData: pushData, items: translations_1.getTranslatedDropdownItems(dropdowns_1.pushpinViewportDropdownItems, intl) })));
}
exports.default = react_intl_1.injectIntl(PushpinViewportControl);
//# sourceMappingURL=PushpinViewportControl.js.map